<aa-action-logs-list-view
  [where]="(query$ | async)?.where"
  [include]="(query$ | async)?.include"
  [orderBy]="(query$ | async)?.orderBy"
  [inComponent]="true"></aa-action-logs-list-view>
